import { render, staticRenderFns } from "./ResearchDate.vue?vue&type=template&id=90aa4090&scoped=true"
import script from "./ResearchDate.vue?vue&type=script&lang=js"
export * from "./ResearchDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90aa4090",
  null
  
)

export default component.exports